import './index.css';
import './assets/sass/theme.scss';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { initApp } from 'helpers';
import { App } from './App';
import { initAppConfig } from './initConfig';

const container = document.getElementById('root');
const root = createRoot(container as HTMLElement);

initApp(initAppConfig).then(() => {
  root.render(<App />);
});
